<div class="dialog">
  <div class="dialog__header" [attr.data-sprintid]="sprint.id">
    <div class="dialog__header-title">Sprint {{isNewSprint ? 'erstellen' : 'bearbeiten'}}</div>

    <div class="dialog__header-buttons">
      <!-- Buttons for existing sprint that is being edited -->
      <button mat-flat-button (click)="openConfirmDeleteDialog($event)" *ngIf="!isNewSprint">
        <mat-icon class="icon icon--primary">delete_outline</mat-icon>
      </button>
      <button mat-flat-button (click)="onDiscardButtonClicked()" id='discard-changes' *ngIf="!isNewSprint">
        <mat-icon class="icon icon--primary">close</mat-icon>
      </button>
      <button mat-flat-button [disabled]="!(sprintHasBeenChanged && formIsValid && !(sprint.state === 'closed'))" (click)="closeThisCard()" *ngIf="!isNewSprint">
        <mat-icon [ngClass]="((sprintHasBeenChanged && formIsValid && !(sprint.state === 'closed'))) ? 'icon icon--primary' : 'icon icon--disabled'">done</mat-icon>
      </button>

      <!-- Buttons for new sprint that has not yet been persisted -->
      <button mat-flat-button *ngIf="isNewSprint" (click)="onDiscardButtonClicked()" >
        <mat-icon class="icon icon--primary">close</mat-icon>
      </button>
      <button mat-flat-button *ngIf="isNewSprint" [disabled]="!(sprintHasBeenChanged && formIsValid)" (click)="createNewSprint()">
        <mat-icon [ngClass]="((sprintHasBeenChanged && formIsValid)) ? 'icon icon--primary' : 'icon icon--disabled'">done</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog__section">
    <!-- Name -->
    <div class="dialog__field">
      <label for="dialog-title" class="dialog__label">{{('components.sprintcard.name' | translate)}}*</label>
      <input type="text" id="dialog-title" class="dialog__input"
             [value]="this.sprint.name" 
             [disabled]="(sprint.state === 'closed')" 
             (input)="sprintNameChanged($event)"
             placeholder="{{('components.sprintcard.namePlaceholder' | translate)}}"
             #dialogTitle>
      <p class="dialog__msg dialog__msg--error" *ngIf="formErrorMessage">{{formErrorMessage}}</p>
    </div>
    <!-- Date From -->
    <div class="dialog__field">
      <label for="dialog-title" class="dialog__label">{{'components.sprintDialog.startdate' | translate}}</label>
      <div class="dialog__datepicker">
        <input 
          [matDatepicker]="sprintDateFrom" 
          [disabled]="(sprint.state === 'closed')" 
          [value]="sprint.startDate" 
          (dateChange)="sprintStartDateChanged($event)">
        <mat-datepicker-toggle [for]="sprintDateFrom"></mat-datepicker-toggle>
        <mat-datepicker touchUi #sprintDateFrom></mat-datepicker>
        <button *ngIf="sprint.startDate && !(sprint.state === 'closed')" 
          (click)="sprintStartDateChanged(null)" mat-button mat-icon-button aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <!-- Date To -->
    <div class="dialog__field">
      <label for="dialog-title" class="dialog__label">{{'components.sprintDialog.enddate' | translate}}</label>
      <div class="dialog__datepicker">
        <input 
          [matDatepicker]="sprintDateTo" 
          [value]="sprint.endDate" 
          [disabled]="(sprint.state === 'closed')" 
          (dateChange)="sprintEndDateChanged($event)">
        <mat-datepicker-toggle [for]="sprintDateTo"></mat-datepicker-toggle>
        <mat-datepicker touchUi #sprintDateTo></mat-datepicker>
        <button *ngIf="sprint.endDate && !(sprint.state === 'closed')" 
          (click)="sprintEndDateChanged(null)" mat-button mat-icon-button aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

  </div>

</div>
